export default "__VITE_ASSET__DkUktW2j__"